import {createI18n} from 'vue-i18n'
// EN
import en from './locales/en/en.json'
import enMenu from './locales/en/enMenu.json'
import enHomePage from './locales/en/enHomePage.json'
import enSeatsPage from './locales/en/enSeatsPage.json'
import enRecovery from './locales/en/enRecovery.json'
import enActivityLogsPage from './locales/en/enActivityLogsPage.json'
import enSettingsPage from './locales/en/enSettingsPage.json'
import enForms from './locales/en/enForms.json'

// ES
import es from '@/boot/i18n/locales/es/es.json'
import esMenu from '@/boot/i18n/locales/es/esMenu.json'
import esHomePage from '@/boot/i18n/locales/es/esHomePage.json'
import esSeatsPage from '@/boot/i18n/locales/es/esSeatsPage.json'
import esRecovery from './locales/es/esRecovery.json'
import esActivityLogsPage from './locales/es/esActivityLogsPage.json'
import esSettingsPage from './locales/es/esSettingsPage.json'
import esForms from './locales/es/esForms.json'

// JP
import ja from './locales/ja/ja.json'
import jaMenu from './locales/ja/jaMenu.json'
import jaHomePage from './locales/ja/jaHomePage.json'
import jaSeatsPage from './locales/ja/jaSeatsPage.json'
import jaRecovery from './locales/ja/jaRecovery.json'
import jaActivityLogsPage from './locales/ja/jaActivityLogsPage.json'
import jaSettingsPage from './locales/ja/jaSettingsPage.json'
import jaForms from './locales/ja/jaForms.json'

// FR
import fr from './locales/fr/fr.json'
import frMenu from './locales/fr/frMenu.json'
import frHomePage from './locales/fr/frHomePage.json'
import frSeatsPage from './locales/fr/frSeatsPage.json'
import frRecovery from './locales/fr/frRecovery.json'
import frActivityLogsPage from './locales/fr/frActivityLogsPage.json'
import frSettingsPage from './locales/fr/frSettingsPage.json'
import frForms from './locales/fr/frForms.json'

// DE
import de from './locales/de/de.json'
import deMenu from './locales/de/deMenu.json'
import deHomePage from './locales/de/deHomePage.json'
import deSeatsPage from './locales/de/deSeatsPage.json'
import deRecovery from './locales/de/deRecovery.json'
import deActivityLogsPage from './locales/de/deActivityLogsPage.json'
import deSettingsPage from './locales/de/deSettingsPage.json'
import deForms from './locales/de/deForms.json'

// IT
import it from './locales/it/it.json'
import itMenu from './locales/it/itMenu.json'
import itHomePage from './locales/it/itHomePage.json'
import itSeatsPage from './locales/it/itSeatsPage.json'
import itRecovery from './locales/it/itRecovery.json'
import itActivityLogsPage from './locales/it/itActivityLogsPage.json'
import itSettingsPage from './locales/it/itSettingsPage.json'
import itForms from './locales/it/itForms.json'

// PT
import pt from './locales/pt/pt.json'
import ptMenu from './locales/pt/ptMenu.json'
import ptHomePage from './locales/pt/ptHomePage.json'
import ptSeatsPage from './locales/pt/ptSeatsPage.json'
import ptRecovery from './locales/pt/ptRecovery.json'
import ptActivityLogsPage from './locales/pt/ptActivityLogsPage.json'
import ptSettingsPage from './locales/pt/ptSettingsPage.json'
import ptForms from './locales/pt/ptForms.json'




const messages = {
  en: {
    common: en,
    menu: enMenu,
    home: enHomePage,
    seats: enSeatsPage,
    recovery: enRecovery,
    activityLogs: enActivityLogsPage,
    settings: enSettingsPage,
    forms: enForms
  },
  es: {
    common: es,
    menu: esMenu,
    home: esHomePage,
    seats: esSeatsPage,
    recovery: esRecovery,
    activityLogs: esActivityLogsPage,
    settings: esSettingsPage,
    forms: esForms
  },
  ja: {
    common: ja,
    menu: jaMenu,
    home: jaHomePage,
    seats: jaSeatsPage,
    recovery: jaRecovery,
    activityLogs: jaActivityLogsPage,
    settings: jaSettingsPage,
    forms: jaForms
  },
  fr: {
    common: fr,
    menu: frMenu,
    home: frHomePage,
    seats: frSeatsPage,
    recovery: frRecovery,
    activityLogs: frActivityLogsPage,
    settings: frSettingsPage,
    forms: frForms
  },
  de: {
    common: de,
    menu: deMenu,
    home: deHomePage,
    seats: deSeatsPage,
    recovery: deRecovery,
    activityLogs: deActivityLogsPage,
    settings: deSettingsPage,
    forms: deForms
  },
  it: {
    common: it,
    menu: itMenu,
    home: itHomePage,
    seats: itSeatsPage,
    recovery: itRecovery,
    activityLogs: itActivityLogsPage,
    settings: itSettingsPage,
    forms: itForms
  },
  pt: {
    common: pt,
    menu: ptMenu,
    home: ptHomePage,
    seats: ptSeatsPage,
    recovery: ptRecovery,
    activityLogs: ptActivityLogsPage,
    settings: ptSettingsPage,
    forms: ptForms
  },
}

const savedLocale = localStorage.getItem('lang')
const supportedLocales = ['en', 'es', 'ja', 'fr', 'de', 'it', 'pt']

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: supportedLocales.includes(savedLocale) ? savedLocale : 'en',
  fallbackLocale: 'en',
  messages,
})

export default i18n
